import Dialogs from './dialogs';

Dialogs.install = (Vue, options) => {
  Vue.prototype.$dialogs = new (Vue.extend(Dialogs))({ propsData: options });
  Vue.dialogs = Vue.prototype.$dialogs;
};

export default Dialogs;
